import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  RDS,
  RootState,
  identifyStrategy,
  strategy,
} from "ouisys-engine/strategy";
import { useSelector } from "react-redux";
import {
  Disclaimers,
  LanguageSwitcher,
  PricePoint,
  TopLegals,
  defineMessages,
} from "ouisys-component-library";
import FLOWS from "./__doNotModify/includedFlows";
import COMP from "./__doNotModify/includedComponents";
import ProvidersWrapper from "./providers/ProvidersWrapper";
import { FormattedMessage, legals } from "./localization";
import Loader from "./components/Loader";
import { useRootContext } from "./providers/RootContext";
import { tracker } from "ouisys-engine/utilities/tracker";
import PreLander from "./components/PreLander";
import { useDispatch } from "./__doNotModify/store";
import "./styles/Main.scss";
// import CheckBoxGR from './components/CheckBoxGR';
// import ExitLinkAE from './components/ExitLinkAE';

// import VideoWrapper from './components/VideoWrapper';

// Define error messages here
const defaultMessages = defineMessages({
  InvalidMSISDN: {
    id: "InvalidMSISDN",
    defaultMessage: "This mobile number is incorrect, try again",
  },
  AlreadySubscribed: {
    id: "AlreadySubscribed",
    defaultMessage: "You are already a subscriber!",
  },
  UnknownError: {
    id: "UnknownError",
    defaultMessage: "An unknown error occurred.",
  },
  InvalidPIN: {
    id: "InvalidPIN",
    defaultMessage:
      "Please enter the correct PIN that you received on your phone",
  },
  SessionBlocked: {
    id: "SessionBlocked",
    defaultMessage: "Session Blocked!",
  },
  TooEarly: {
    id: "TooEarly",
    defaultMessage: "You must first submit a mobile number",
  },
  didnt_receive_pin_yet: {
    id: "didnt_receive_pin_yet",
    defaultMessage: "Didn't receive PIN yet?",
  },
});

const Root = () => {
  const { currentState } = useSelector((state: RootState) => state.strategy);
  const {
    locale,
    switchLang,
    skipPrelander,
    setPrelander,
    phoneInputRef,
    setShake,
    d_theme,
    isVideoActive,
    setIsVideoActive,
  } = useRootContext();
  const [showOverlay, setShowOverlay] = useState(false);
  const dispatch = useDispatch();

  // Image src
  const serviceLogo = require("./assets/imgs/gamingclub_logo.svg");
  const creativeImg = require("./assets/imgs/tick_animation.gif");

  const editedLegals = [
    {
      ...legals[0],
      disclaimer: legals[0].disclaimer.replace(
        '<span class="email-contact"></span>',
        "gamingclub.si@silverlines.info "
      ),
    },
  ];

  // when user clicks on the creative area, we show an overlay
  // so the user will focus on the subscription form
  // Function to handle the div focus, now optimized with useRef and useState
  // const divFocus = useCallback(() => {
  //   tracker.customEvent('creativeArea', 'click', 'form-focus');
  //   setShowOverlay(true);
  //   setShake(true);

  //   if (phoneInputRef.current) {
  //     phoneInputRef.current.focus();
  //   }
  //   // Trigger a vibration if available
  //   if ('vibrate' in navigator) {
  //     navigator.vibrate([100, 30, 100, 30, 100]);
  //   }

  //   // Reset shake effect after 1 second (or the duration of your shake animation)
  //   setTimeout(() => setShake(false), 1000);
  // }, []);

  const identifyStrategyEffect = useCallback(() => {
    dispatch(identifyStrategy());
  }, [dispatch]);

  useEffect(() => {
    identifyStrategyEffect();
  }, [identifyStrategyEffect]);

  // const showVideo = () => {
  //   if (!isVideoActive) {
  //     tracker.advancedInPreFlow('click-play');
  //     setIsVideoActive(true);
  //   } else {
  //     divFocus();
  //   }
  // };

  return (
    <div
      className={`page-${locale} overlay-${showOverlay} skip-prelander-${skipPrelander}`}
    >
      {/* pre-lander */}
      {!skipPrelander && (
        <PreLander
          contentLoaded={() => {
            tracker.advancedInPreFlow("advance-auto", "step1");
            setPrelander(true);
          }}
        />
      )}

      <header>
        <div className="container">
          <div className="header-left">
            <img src={serviceLogo} className="service-logo" />
          </div>
          <div className="header-center">
            <TopLegals className="top-legals" locale={locale} legals={legals} />
            {/* optional div for video vertical */}
            {/* <div className="video-search" /> */}
          </div>
          <div className="header-right">
            {/* optional div for video vertical */}
            {/* <div className="video-menu" /> */}
            {/* <LanguageSwitcher
              locale={locale}
              switchLang={switchLang}
              options={[
                { value: 'en', label: 'English' },
                { value: 'ar', label: 'عربى' }
              ]}
              className="switch-lang"
              tracker={tracker}
            /> */}
          </div>
        </div>
      </header>

      <main>
        <section className={`creative-area with-prelander-${skipPrelander}`}>
          <div className="container">
            <img src={creativeImg} className="creative-img" />
          </div>
        </section>

        <section
          className="subscription-area"
          onClick={(ev) => ev.stopPropagation()}
        >
          {/* To convert this to Video vertical, you can wrap the container with the subcription-box inside VideoWrapper */}
          {/* <VideoWrapper> */}
          <div className="container">
            <div className="subscription-box">
              {strategy({
                identifyInitialState: () => <Loader />,
                identifyFlowByMsisdn: (rds) => (
                  <COMP.IdentifyFlowByMsisdn rds={rds} />
                ),
                identifyFlowByOperatorSelect: () => <COMP.OperatorSelection />,
                pinFlow: () => <FLOWS.PinFlow />,
                moFlow: () => <FLOWS.MoFlow />,
                moRedirFlow: () => <FLOWS.MoRedirFlow />,
                oneClickFlow: () => <FLOWS.OneClickFlow />,
                click2smsFlow: () => <FLOWS.Click2smsFlow />,
                ussdFlow: () => <FLOWS.UssdFlow />,
                creditCardFlow: () => <FLOWS.CreditCardFlow />,
              })(currentState)}
              {RDS.WhenLoading(null, () => <Loader />)(
                currentState?.result as RDS.RemoteDataState<unknown, unknown>
              )}
            </div>
            {/* <ExitLinkAE /> */}
          </div>
          {/* </VideoWrapper> */}
        </section>
      </main>

      <footer>
        <div className="container">
          <Disclaimers
            className="disclaimer"
            locale={locale}
            legals={editedLegals}
          />
        </div>
      </footer>
    </div>
  );
};

const R = () => (
  <ProvidersWrapper>
    <Root />
  </ProvidersWrapper>
);

export default R;
